import axios from 'axios';
import { baseUrl } from '@/config';
import { forEach } from 'lodash';

export default {
  /**
   * [네트워크 설정 > 장비 계정 관리 > 계정 관리 정보를 가져온다]
   * @author Song
   * @return {[type]}   [description]
   */
  getDeviceAccountSyncList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-account-settings/get-device-account-sync-list.do`, params);
  },
  /**
   * [네트워크 설정 > 장비 계정 관리 > 계정 관리 정보를 수정한다.
   * @author Song
   * @return {[type]}   [description]
   */
  updateDeviceAccountSyncList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-account-settings/update-device-account-sync-list.do`, params);
  },
  /**
   * [네트워크 설정 > 장비 계정 관리 > 계정 관리 정보 엑셀 출력
   * @author Song
   * @return {[type]}   [description]
   */
  exportNetDeviceAccountList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/settings/netdevice-account-settings/export-netdevice-account-list.do`;
    form.method = 'get';
    forEach(params, (value, key) => {
      if (params[key] && (key === 'objCompanyId' || key === 'objId')) {
        const hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
      }
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    // window.location.assign(`${baseUrl}/settings/netdevice-account-settings/export-netdevice-account-list.do?objCompanyId=${params.objCompanyId}&objId=${params.objId}`);
  },
  /**
   * [장비 모델 관리 > 장비 계정 관리 > 계정 관리 정보 엑셀 템플릿 다운
   * @author Song
   * @return {[type]}   [description]
   */
  downloadNetdeviceAccountTemplate() {
    window.location.assign(`${baseUrl}/settings/netdevice-account-settings/download-netdevice-account-template.do`);
  },
  /**
   * [장비 모델 관리 > 장비 계정 관리 > 장비 계정 관리 정보 - 동기화 이력을 가져온다.
   * @author Song
   * @return {[type]}   [description]
   */
  getDeviceAccountSyncHistList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-account-settings/get-device-account-sync-hist-list.do`, params);
  },
  /**
   * [장비 모델 관리 > 장비 계정 관리 > 장비 계정 관리 정보 - 패스워드 변경 이력을 가져온다.
   * @author Song
   * @return {[type]}   [description]
   */
  getDeviceAccountPwdHistList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-account-settings/get-device-account-pwd-hist-list.do`, params);
  },
  /**
   * [장비 모델 관리 > 장비 계정 관리 > 장비계정 동기화 이력정보 엑셀 출력
   * @author Song
   * @return {[type]}   [description]
   */
  exportDeviceAccountSyncHistList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/settings/netdevice-account-settings/export-netdevice-account-sync-hist.do`;
    form.method = 'get';
    forEach(params, (value, key) => {
      if (params[key] && (key === 'objCompanyId' || key === 'objId')) {
        const hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
      }
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    // window.location.assign(`${baseUrl}/settings/netdevice-account-settings/export-netdevice-account-sync-hist.do?objCompanyId=${params.objCompanyId}&objId=${params.objId}`);
  },
  /**
   * [장비 모델 관리 > 장비 계정 관리 > 계정 관리 정보 엑셀 템플릿 다운
   * @author Song
   * @return {[type]}   [description]
   */
  exportDeviceAccountPwdHistList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/settings/netdevice-account-settings/export-netdevice-account-pwd-hist.do`;
    form.method = 'get';
    forEach(params, (value, key) => {
      if (params[key] && (key === 'objCompanyId' || key === 'objId')) {
        const hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
      }
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    // window.location.assign(`${baseUrl}/settings/netdevice-account-settings/export-netdevice-account-pwd-hist.do?objCompanyId=${params.objCompanyId}&objId=${params.objId}`);
  },
  /**
   * [장비 모델 관리 > 장비 계정 관리 > 장비 계정 관리 정보 - 동기화 추가 팝업창 - 트리 로드
   * @author Song
   * @return {[type]}   [description]
   */
  getPhysicalTreeWithSyncData() {
    return axios.get(`${baseUrl}/settings/netdevice-account-settings/get-physical-tree-with-sync.do`);
  },
  /**
   * [장비 모델 관리 > 장비 계정 관리 > 장비 계정 관리 정보 - 동기화 추가 팝업창 - 계정 동기화 이력을 남기고 DM 호출 한다.
   * @author Song
   * @return {[type]}   [description]
   */
  deviceAccountSync(params) {
    return axios.post(`${baseUrl}/settings/netdevice-account-settings/sync-device-account.do`, params);
  },
  /**
   * [장비 모델 관리 > 장비 계정 관리 > 장비 계정 관리 정보 - 동기화 추가 팝업창 - 이력 시퀀스의 동기화 상태를 가져온다.
   * @author Song
   * @return {[type]}   [description]
   */
  getStatusBySyncHist(params) {
    return axios.get(`${baseUrl}/settings/netdevice-account-settings/get-status-by-sync-hist.do?histSeq=${params.histSeq}`);
  },
  /**
   * [장비 모델 관리 > 장비 계정 관리 > 장비 계정 관리 정보 - 계정 정보 업데이트 엑셀 입력
   * @author Song
   * @return {[type]}   [description]
   */
  importDeviceSync(params) {
    return axios.post(`${baseUrl}/settings/netdevice-account-settings/device-sync-excel-import.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/netdevice/netdevice-account-settings.js